import { Component, Input } from '@angular/core'
import { ICustomTableColumn } from '../../modals/interface/custom-table.interface'
import { CustomTableService } from '../../service/custom-table.service'

@Component({
    selector: 'app-column-control-base',
    templateUrl: './column-control-base.component.html',
    styleUrls: ['./column-control-base.component.scss'],
    standalone: false
})
export class ColumnControlBaseComponent {
  @Input() row: any
  @Input() column: ICustomTableColumn

  constructor(public customTableService: CustomTableService) {}

  public get rowHasData(): boolean {
    const value = this.getData
    return value !== undefined && value !== null
  }

  public get getData(): any {
    return this.row[this.column.finalKey]
  }

  public onClick(control: any): void {
    console.log('this.row value....>', this.row)
    this.customTableService.clicked(control, this.row)
  }
}
